module.exports = __webpack_public_path__ + "static/media/TopMiddleBottomIcon.392fc980.svg";